import React from 'react';
import {
  apiV2UsersRemove,
} from '../../../../../../api/merchant/users';
import {
  openPopupWindow,
  openPopupInfo,
} from '../../../../../../emitters/popup';
import WrapperWithLoading from '../../../../../dumb/WrapperWithLoading/B';
import Popup from '../../../../../dumb/Popup/B';
import ButtonDecline from '../../../../../dumb/Button/Decline';
import ButtonRed from '../../../../../dumb/Button/Red';
import FieldC from '../../../../../dumb/Field/C';
import Tooltip from '../../../../../dumb/Tooltip/B';


module.exports = (data, callback) => {
  data = data || {};
  const {
    email,
  } = data;

  openPopupWindow((setPopupState, popup) => {
    const {
      close,
    } = popup;
    return (stateOfPopup) => {
      return (
        <Popup caption="Are you sure you want to delete this user?">
          <WrapperWithLoading
            loading={stateOfPopup.loading}
          >
            <div className="cfx mt30 mh-10 (lt|ph10|w1/3|w1/4@d2|w1/2@m|w@m2)>1">
              <FieldC
                label="Email"
                value={email}
              />
              <FieldC
                label="Name"
                value={data.name}
              />
              <FieldC
                label="Role"
                value={data.role}
              />
              <FieldC
                label="Permissions"
                value={(<Tooltip>{data.permissions}</Tooltip>)}
              />
            </div>
            <div className="cfx mh-10 (lt|ph10|pt20)>1">
              <div>
                <ButtonRed
                  onClick={() => {
                    setPopupState({
                      loading: true,
                    });
                    apiV2UsersRemove({
                      id: data.id,
                    }).finally((error) => {
                      setPopupState({
                        loading: false,
                      });
                      if (error) {
                        return;
                      }
                      close();
                      openPopupInfo([`User ${email} deleted`]);
                      callback && callback();
                    });
                  }}
                >Delete</ButtonRed>
              </div>
              <div>
                <ButtonDecline
                  onClick={close}
                >Cancel</ButtonDecline>
              </div>
            </div>
          </WrapperWithLoading>
        </Popup>
      );
    };
  });
};
